import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { EntityDetail } from '../Models/entity-detail';
import { ClientListing } from '../Models/clients';
import { BankDetail } from '../Models/billing';
import { Auditors } from '../Models/auditModel';
import { Address, Corporate } from '../Models/contacts';
import { PersonalDetails } from '../Models/contacts';
import { SMClientService } from './SM-client.service';
import { noLoaderContextValue } from '../commonservice/authentication.interceptor';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ClientService {
  public entityDetail = new EntityDetail();
  public CorporateEntityDetails = new Corporate();
  public personalDetail = new PersonalDetails();
  public bankDetail = new BankDetail();
  public auditors = new Auditors();
  public homeAddressModel = new Address();
  public postalAddressModel = new Address();
  public corporate = new Corporate();
  public notificationHeaders: HttpHeaders;
  public state;
  public clientId;
  public entityId;
  private headers: HttpHeaders;
  private urlEncodedHeaders: HttpHeaders;
  // Bare Trust Details
  public bareTrustRows = [{

    specialPurposeCompany: {},
    clientId: 0,
    entityId: 0,
    childEntityId: 0,
    bareTrustName: '',
    ABN: '',
    addRow: true
  }];
  specialPurposeCompRow: any[] = [{
    company: '',
    ABN: '',
    ACN: '',
    AnniversaryDate: ''
  }];

  constructor(private http: HttpClient, private stateManagement: SMClientService) {
    this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    this.urlEncodedHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    this.notificationHeaders = new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
  }

  addEditMemberDetails(data) {
    return this.http.post<any>('Member/AddEntityMember', data)
  }

  getMembersList(entityId, memberId, type) {
    return this.http.get<any>('Member/GetEntityMember?EntityId=' + entityId + '&MemberId=' + memberId + '&Type=' + type)
  }

  deleteMember(memberId, type) {
    return this.http.get<any>('Member/DeleteMemberById?memberId=' + memberId + '&type=' + type)
  }

  addEditClient(clientData) {
    return this.http.post<any>('Client/AddEditClient', clientData)
  }

  invalidateCache(refreshMethod: string): Observable<any> {
    return this.http.post<any>('CacheRefresh/InvalidateCache?refreshMethod=' + refreshMethod,null, { headers: this.headers });
  }

  updateAllTasksToComplete(jobId) {
    return this.http.post<any>('ClientProfile/Update_AllTaskStatus_Complete?jobId=' + jobId, { headers: this.headers });
  }

  addEditSpouseDetails(clientData) {
    return this.http.post<any>('Client/AddEditSpouseInfo', clientData)
  }

  async GetClientListPromiseAsync(searchTxt, isArchive, statusId, vid) {
    return await this.http.get<any>('Client/GetClientList?searchTxt=' + searchTxt + '&isArchive=' + isArchive + '&statusId=' + statusId + '&isLoadFirstTime=' + vid).toPromise();
  }

  async GetClientListPromiseAsyncJson(searchTxt, isArchive, statusId, vid) {
    return await this.http.get<any>('Client/GetClientListJson?searchTxt=' + searchTxt + '&isArchive=' + isArchive + '&statusId=' + statusId + '&isLoadFirstTime=' + vid).toPromise();
  }

  public GetClientListPromiseAsyncJsons(searchTxt: string, isArchive: boolean, statusId, vid): Observable<any> {
    const url = 'Client/GetClientListJson_V1?searchTxt=' + searchTxt + '&isArchive=' + isArchive + '&statusId=' + statusId + '&isLoadFirstTime=' + vid;
    return this.http.get<any>(url, { context: noLoaderContextValue });
  }

  async GetClientListForGroupAsync() {
    return await this.http.get<any>('Client/GetClientListForGroupAsync').toPromise();
  }

  GetClientListForGroupAsyncs(): Observable<any> {
    return this.http.get<any>('Client/GetClientListForGroupAsync');
  }

  async GetClientList(searchTxt, isArchive, statusId, vid) {
    return await this.http.get<ClientListing[]>('Client/GetClientList?searchTxt=' + searchTxt + '&isArchive=' + isArchive + '&statusId=' + statusId + '&isLoadFirstTime=' + vid);
  }

  GetContactDropdownList() {
    return this.http.get<any>('Client/GetContactDropdownList');
  }

  GetContactList(searchTxts) {
    return this.http.get<any>('Client/GetContactList?searchTxt=' + searchTxts + '');
  }

  GetAllContactList(searchTxts, allflag) {
    return this.http.get<any>('Client/GetContactList?searchTxt=' + searchTxts + '&allflag=' + allflag);
  }

  GetClientListByContactId(ConId) {
    return this.http.get<any>('Client/GetClientListByContactId?contactId=' + Number(ConId) + '', { context: noLoaderContextValue });
  }

  GetContactDetailsById(ConId) {
    return this.http.get<any>('Client/GetContactDetailsById?contactId=' + ConId)
  }

  getContactDetails(contactId: number, clientId: number) {
    return this.http.get<any>(
      `Client/GetContactDetails?contactId=${contactId}&ClientId=${clientId}`
    );
  }

  DeleteContactById(ConId) {
    return this.http.get<any>('Client/DeleteContactById?contactId=' + ConId)
  }

  deleteContact(contactId: number, clientId: number) {
    return this.http.get<any>(
      `Client/DeleteContact?contactId=${contactId}&ClientId=${clientId}`
    );
  }

  getImportantContacts(contactId: number, clientId: number) {
    return this.http.get<any>(`Client/ImportentContacts?contactId=${contactId}&ClientId=${clientId}`);
  }

  getImportantAddress(addressId: number, val: string) {
    return this.http.get<any>(`Client/ImportentAddress?AddressId=${addressId}&val=${val}`);
  }

  getClientFileView(clientId: number) {
    return this.http.get<any>(`Client/GetClientFileView?clientId=${clientId}`);
  }
  addEditClientActivity(model: any, formData: FormData, ddate: string) {
    return this.http.post<any>(
      `Client/AddEditClientActivity/?activityID=${model.ActivityId}&clientId=${model.ClientId}&activityName=${model.ActivityName}&status=${model.Status}&priority=${model.Priority}&description=${model.Description}&dueDate=${ddate}&assingee=${model.assignee}`,
      formData,
      { headers: this.headers }
    );
  }

  addEditClientProfileImg(client: any) {
    return this.http.post<any>(
      'Client/AddEditClientProfileImg',
      client,
      { headers: this.headers }
    );
  }


  archiveClientActivity(activityId: number) {
    return this.http.get<any>(`Client/ArchiveClientActivity?activityID=${activityId}`);
  }


  getAllTagdetailsforclient() {
    return this.http.get<any>('Client/GetAllTagdetailsforclient');
  }

  getsoftwaredetails(clientId, entityId) {
    return this.http.get<any>('Client/GetSoftwareDetails?clientId=' + clientId + '&entityId=' + entityId)
  }

  GetClientProfileEntityList(clientId) {
    return this.http.get<any>('ClientProfile/GetClientProfileEntityList?clientId=' + clientId)
  }

  GetClientTaskRelplyById(clientId, cid) {
    return this.http.get<any>('ClientProfile/GetClientTaskRelplyById?ClientId=' + clientId + '&cid=' + cid)
  }

  GetJobNotesReplyById(taskId, jobId) {
    return this.http.get<any>('ClientProfile/GetJobNotesReplyById?TaskId=' + taskId + '&JobID=' + jobId)
  }

  GetClientTaskRelplyByClientId(clientId) {
    return this.http.get<any>('ClientProfile/GetClientTaskReplyByClientId?ClientId=' + clientId)
  }

  GetClientActivityRelplyById(clientId) {
    return this.http.get<any>('ClientProfile/GetClientActivityRelplyById?ClientId=' + clientId)
  }

  GetClientProfileOpportunityList(clientId, isArchive) {
    return this.http.get<any>('ClientProfile/GetClientProfileOpportunityList?clientId=' + clientId + '&isArchive=' + isArchive)
  }

  GetClientProfileTaskList(clientId, isArchive) {
    return this.http.get<any>('ClientProfile/GetClientProfileTaskList?clientId=' + clientId + '&isArchive=' + isArchive)
  }

  GetClientProfileNotesList(clientId, isArchive, ContextType) {
    return this.http.get<any>('ClientProfile/GetClientProfileNotesList?clientId=' + clientId + '&isArchive=' + isArchive + '&ContextType=' + ContextType)
  }

  GetClientProfileJobList(EntityID) {
    return this.http.get<any>('ClientProfile/GetClientProfileJobList?EntityID=' + EntityID)
  }

  softwaredetails(softwareDetailId) {
    return this.http.get<any>('Client/GetSoftwareDetailById?softwareDetailId=' + softwareDetailId + '')
  }

  addsoftwaredetails(softwaredetails) {
    return this.http.post<any>('Client/PostSoftwareDetails', softwaredetails)
  }

  deletesoftwaredetails(id) {
    return this.http.get<any>('Client/DeleteSoftwareDetailById?softwareDetailId=' + id + '')
  }

  //get Client By Profile By ID
  GetClientProfileById(clientId) {
    return this.http.get<any>('ClientProfile/GetClientProfileById?ClientId=' + clientId + '');
  }

  //Get Clinet Communication Details by Clinet Id
  GeClientProfileCommunication(clientId, isArchive) {
    return this.http.get<any>('ClientProfile/GeClientProfileCommunication?ClientId=' + clientId + '&isArchive=' + isArchive);
  }

  //Add Communication
  AddOrUpdateCommunication(communication) {
    return this.http.post<any>('ClientProfile/AddOrUpdateCommunication', communication, { headers: this.headers });
  }

  AddOrUpdateNotes(notes) {
    return this.http.post<any>('ClientProfile/AddOrUpdateNotes', notes, { headers: this.headers });
  }

  AddOrUpdateTask(formData) {
    return this.http.post<any>('ClientProfile/AddOrUpdateTask', formData, { headers: this.headers });
  }

  AddTaskReply(taskReply) {
    return this.http.post<any>('ClientProfile/AddTaskReply', taskReply, { headers: this.headers });
  }

  AddJobNotesReply(jobNotesReply) {
    return this.http.post<any>('ClientProfile/AddJobNotesReply', jobNotesReply, { headers: this.headers });
  }

  AddClientActivityReply(taskReply) {
    return this.http.post<any>('ClientProfile/AddClientActivityReply', taskReply, { headers: this.headers });
  }

  //Delete Communication Based on Communication ID
  DeleteCommunication(commID) {
    return this.http.get<any>('ClientProfile/DeleteCommunication?commID=' + commID)
  }

  GetCommunicationDetails(commID) {
    return this.http.get<any>('ClientProfile/GetCommunicationDetails/' + commID + '', { headers: this.headers })
  }

  GetNotesDetails(noteId) {
    return this.http.get<any>('ClientProfile/GetNotesDetails?noteId=' + noteId)
  }
  
  archivedNotes(noteId: any, isArchive: boolean = true, clientId: any) {
    return this.http.post<any>('ClientProfile/archiveClientNoteById?noteId=' + noteId + '&clientId=' + clientId + '&isArchive=' + isArchive,{ headers: this.headers })
  }
  
  unArchiveClientNote(noteId: number) {
    return this.http.get<any>('ClientProfile/unArchiveClientNoteById?noteID=' + noteId);
  }
  getStaffLists(clientId) {
    return this.http.get<any>('Client/GetAssignStaffListForClient?clientId=' + clientId);
  }

  GetAllEntityforClient(clientId) {
    return this.http.get<any>('Client/GetAllEntityforClient?clientId=' + clientId);
  }

  DeleteTask(taskId) {
    return this.http.get<any>('ClientProfile/DeleteTask?taskId=' + taskId)
  }

  DeleteTaskReply(taskId, TaskReplyID) {
    return this.http.get<any>('ClientProfile/DeleteTaskReply?taskId=' + taskId + '&TaskReplyID=' + TaskReplyID)
  }

  UpdateTaskReply(taskId, TaskReplyID, reply, taguser) {
    return this.http.get<any>('ClientProfile/UpdateTaskReply?taskId=' + taskId + '&TaskReplyID=' + TaskReplyID + '&Message=' + reply + '&taguser=' + taguser)
  }

  DeleteNotes(notesId) {
    return this.http.get<any>('ClientProfile/DeleteNotes?notesId=' + notesId)
  }

  ArchiveOpportunity(jobId) {
    return this.http.get<any>('ClientProfile/ArchiveOpportunity?jobId=' + jobId)
  }

  ArchiveClients(clientId) {
    return this.http.get<any>('Client/ArchiveClient?ClientId=' + clientId)
  }

  GetTagdetailsclients(isArchive) {
    return this.http.get<any>('Client/GetTagdetailsclients?isArchive=' + isArchive)
  }

  GetTagdetailsListbyClientid(ClientId) {
    return this.http.get<any>('Client/GetTagdetailsListbyClientid?ClientId=' + ClientId)
  }

  Addtagclient(tagId, ClientId) {
    return this.http.get<any>('Client/Addtagclient?tagId=' + tagId + '&ClientId=' + ClientId)
  }

  DeleteTagById(tagId, ClientId) {
    return this.http.get<any>('Client/DeleteTagById?tagId=' + tagId + '&ClientId=' + ClientId)
  }

  ChangeClientstatusById(ClientId, Status) {
    return this.http.get<any>('Client/UpdateClientStatusById?ClientId=' + ClientId + '&Status=' + Status)
  }

  GetCustomClientList() {
    return this.http.get<any>('Client/GetClientCustomList');
  }

  GetCustomClientListExport() {
    return this.http.get<any>('Client/GetClientCustomListExport');
  }

  GetClientCustomListSystemFilter(AllStatus, active, archive, prospect, individual, comp, partner, SMSF, Trust) {
    return this.http.get<any>('Client/GetClientCustomListSystemFilter?AllStatus=' + AllStatus + '&active=' + active + '&archive=' + archive + '&prospect=' + prospect + '&individual=' + individual + '&comp=' + comp + '&partner=' + partner + '&SMSF=' + SMSF + '&Trust=' + Trust)
  }

  GetFilterList() {
    return this.http.get<any>('Client/GeFilterList');
  }

  GetCustomeDynamicFilterList() {
    return this.http.get<any>('Client/GeDynamicFilterList');
  }

  DeleteAndUpdateDynamicFilter(filterId, isDeleted, isFavroite) {
    return this.http.get<any>('Client/DeleteAndUpdateDynamicFilter?filterId=' + filterId + '&isDeleted=' + isDeleted + '&isFavroite=' + isFavroite)
  }

  GetCustomeDynamicFilterListByFilterId(filterId) {
    return this.http.get<any>('Client/GeDynamicFilterListByFilterId?filterId=' + filterId);
  }

  getClientListByCustomeFilter(filterId) {
    return this.http.get<any>('Client/getClientListByCustomeFilter?filterId=' + filterId);
  }

  GetContactforClient(clientID) {
    return this.http.get<any>('Client/GetContactforClient?ClientId=' + clientID);
  }

  GetClientGroups(groupCode) {
    return this.http.get<any>('Client/GetClientGroups?groupCode=' + groupCode);
  }

  AddEditClientGroups(clientGroupModel) {
    return this.http.post<any>('Client/AddEditClientGroups', clientGroupModel, { headers: this.headers });
  }

  UpdateClientBasicInfo(client) {
    return this.http.post<any>('Client/UpdateClientBasicInfo', client, { headers: this.headers });
  }

  UpdateContactInfo(client) {
    return this.http.post<any>('Client/UpdateContactInfo', client, { headers: this.headers });
  }
  UpdateFinancialInfo(client) {
    return this.http.post<any>('Client/UpdateFinancialInfo', client, { headers: this.headers });
  }

  CheckGroupNameExists(groupName: string, groupId: string | null = null) {
    let params = new HttpParams().set('groupName', groupName);
    if (groupId) {
      params = params.set('groupId', groupId);
    }
    return this.http.get<any>('Client/CheckGroupNameExists', { params });
  }

  getDebtorJobDetailsByGroupId(groupCode: number)
  {
    return this.http.get<any>(`client/GetDebtorJobDetailsForGroup/?groupCode=${groupCode}`);
  }


  UpdateCustomFields(client) {
    return this.http.post<any>('Client/UpdateCustomFields', client, { headers: this.headers });
  }

  DeleteClientGroup(groupClientModel) {
    return this.http.post<any>('Client/DeleteClientGroup', groupClientModel, { headers: this.headers });
  }

  DeleteClientGroupClient(groupClientModel) {
    return this.http.post<any>('Client/DeleteClientGroupClient', groupClientModel, { headers: this.headers });
  }

  AddEditGroupPartners(groupPartners) {
    return this.http.post<any>('Client/AddEditGroupPartners', groupPartners, { headers: this.headers });
  }

  GetGroupPartners() {
    return this.http.get<any>('Client/GetGroupPartners');
  }

  GetClientforRelationship(clientID) {
    return this.http.get<any>('Client/GetClientforRelationship?ClientId=' + clientID);
  }

  GetCreditNotes(clientID) {
    return this.http.get<any>('Client/GetCreditNotes?ClientId=' + clientID);
  }

  GetJobNamesbyClientId(clientID) {
    return this.http.get<any>('Client/GetJobNamesbyClientId?ClientId=' + clientID);
  }

  DeleteCreditNote(CNId) {
    return this.http.get<any>('Client/DeleteCreditNote?CreditId=' + CNId);
  }

  GetDocumentDetailsbyCNoteId(CNId) {
    return this.http.get<any>('Client/GetDocumentDetailsbyCNoteId?CreditId=' + CNId);
  }

  GetTitleList() {
    if (this.stateManagement.getTitleList.value == null) {
      return this.http.get<any>('Client/GetTitleList');
    } else {
      return this.stateManagement.getTitleList;
    }
  }

  GetClientListingCombo() {
    return this.http.get<any>('Client/GetClientListingCombo');
  }

  DeleteCustomClientViewById(id) {
    return this.http.post<any>('Client/DeleteCustomClientView?id=', id, { headers: this.headers });
  }

  AddEditClientListingCustomView(formPosted) {
    return this.http.post<any>('Client/AddEditClientListingCustomView', formPosted, { headers: this.headers });
  }

  GetClientListingView() {
    if (this.stateManagement.getClientsListView.value == null) {
      return this.http.get<any>('Client/GetClientListingCustomView');
    } else {
      return this.stateManagement.getClientsListView;
    }
  }

  GetClientListingViewById(vwId) {
    return this.http.get<any>('Client/GetClientListingCustomView?id=' + vwId);
  }

  GetDataforBillingWidgets(clientID) {
    return this.http.get<any>('Client/GetDataforBillingWidgets?ClientId=' + clientID);
  }

  GetDataforAgedWip(clientID) {
    return this.http.get<any>('Client/GetDataforAgedWip?ClientId=' + clientID);
  }

  GetDataforWidgets(clientID) {
    return this.http.get<any>('Client/GetDataforWidgets?ClientId=' + clientID);
  }

  GetWidgetsData(clientID, flag = '') {
    return this.http.get<any>('Client/GetWidgetsData?ClientId=' + clientID + '&Flag=' + flag);
  }

  GetClientAgedWipReport(clientId: any, clientFlag?: string /* 'Client' | 'Debtor' */) {
    return this.http.get<any>(`Client/GetClientAgedWipReport?ClientId=${clientId}&ClientFlag=${clientFlag}`);
  }

  GetClientAgedDebtReportSummary(clientId: any, clientFlag?: string /* 'Client' | 'Debtor' */) {
    return this.http.get<any>(`Client/GetClientAgedDebtReportSummary?ClientId=${clientId}&ClientFlag=${clientFlag}`);
  }

  GetClientTasksForDashboard(JobId, isArchive, currentDate) {
    return this.http.get<any>('Task/GetTaskList?JobId=' + JobId + '&isArchive=' + isArchive + '&currentDate=' + currentDate, { headers: this.urlEncodedHeaders });
  }

  GetDebtorClient(clientID, clientType) {
    return this.http.get<any>('Client/GetDebtorClient?ClientId=' + clientID + '&ClientType=' + clientType);
  }

  AddEditClientFilter(formPosted) {
    return this.http.post<any>('Client/AddEditClientFilter', formPosted, { headers: this.headers });
  }

  GetClientFilter(id) {
    return this.http.get<any>('Client/GetClientFilter?ViewId=' + id);
  }

  GetContactById(id) {
    return this.http.get<any>('Client/GetContactById?ContactId=' + id);
  }

  GetClientContactDetails(ClientId) {
    return this.http.get<any>('Client/GetClientContactDetails?ClientId=' + Number(ClientId) + '', { headers: this.headers });
  }

  AddEditClientContact(ClientId, ContactIds) {
    return this.http.post<any>('Client/AddEditClientContact?ClientId=' + Number(ClientId) + '&ContactIds=' + ContactIds + '', { headers: this.headers });
  }

  GetCustomFields(Id) {
    return this.http.get<any>('Client/GetCustomFields?Id=' + Id);
  }

  GetCustomFieldValues(Id) {
    return this.http.get<any>('Client/GetCustomFieldValues?Id=' + Id);
  }

  GetGroupClient(ClientId) {
    return this.http.get<any>('Client/GetGroupClient?ClientId=' + Number(ClientId));

  }

  GetClientsTags(clientIds: any) {
    return this.http.post<any>('Client/GetClientsTags', clientIds);
  }

  DeleteClientsTags(clients: any[], tags: any[]): Observable<any> {

    return this.http.post<any>('Client/DeleteClientsTags',
      {
        Clients: clients,
        Tags: tags
      }
    );
  }

  NotifyUserTagging(noteId, users) {
    return this.http.post<any>('ClientProfile/NotifyUserTagging?noteId=' + noteId + '&users=' + users, { headers: this.headers });
  }

  GetNotesDetailsByReplyId(noteId) {
    return this.http.get<any>('ClientProfile/GetNotesDetailsByReplyId?noteId=' + noteId)
  }

  GetNotesDetailsByTaskReplyId(noteId) {
    return this.http.get<any>('ClientProfile/GetNotesDetailsByTaskReplyId?noteId=' + noteId)
  }

  GetClientId(jobId) {
    return this.http.get<any>('Client/GetClientId?CommentId=' + jobId)
  }

  GetAllWidgetsData(clientID, jobId, flag = '') {
    return this.http.get<any>('Client/GetAllWidgetsData?ClientId=' + clientID + '&JobId=' + jobId + '&Flag=' + flag);
  }

  GetCreditNoteReport(cNId) {
    return this.http.get<any>('Client/GetCreditNoteReport?cNId=' + cNId);
  }

  GetClientHaveFinalInvoice(clientId) {
    return this.http.get<any>('Client/GetClientHaveFinalInvoice?clientId=' + clientId);
  }

  GetTeamMembers(teamId) {
    return this.http.get<any>('TeamGroups/TeamGroups?teamId=' + teamId);
  }

  getReciepients(id: number) {
    return this.http.get<any>('client/GetRecipientsDetails?clientId=' + id);
  }

  GetRelationshipTypeData(entityTypeId) {
    return this.http.get<any>('Client/GetRelationshipType?EntityTypeId=' + entityTypeId);
  }

  GetEntityData(clientId, relationshipId) {
    return this.http.get<any>('Client/GetEntitiesForRelationshipMapping?clientId=' + clientId + '&relationshipId=' + relationshipId);
  }

  addRelationshipData(data) {
    return this.http.post<any>('Client/AddEntityClientRelationship', data);
  }

  DeleteClientRelation(data) {
    return this.http.get<any>('Client/DeleteClientrelation?entityId=' + data.entityId + '&ClientId=' + data.ClientId + '&relationshipId=' + data.relationshipId + '&relationshipMappingId=' + data.relationShipMappingId);
  }

  modifiedAddress(data) {
    return this.http.post<any>('Client/OnAddressChange', data);
  }

  notifyAddressChange(requestBody: any) {
    return this.http.post<any>('Client/NotifyAddressChange', requestBody, { headers: this.headers });
  }

  addEditClientSuggestEntities(requestBody: any): Observable<any> {
    return this.http.post<any>('Client/SuggestEntities', requestBody, { headers: this.headers })
  }

  addEditClientAsic(requestBody: any): Observable<any> {
    return this.http.post<any>('Client/AddClientFromConnectionRelation', requestBody, { headers: this.headers })
  }

  addEditContactAsic(requestBody: any): Observable<any> {
    return this.http.post<any>('Client/AddContactFromConnectionRelation', requestBody, { headers: this.headers })
  }

  addEditmapClientOrContactRelation(requestBody: any): Observable<any> {
    return this.http.post<any>('Client/MapClientOrContactWithRelation', requestBody, { headers: this.headers })
  }

  GetClientJoblist() {     //Ramya Krishna, CUST-4618, 14-08-2024
    return this.http.get<any>('Client/GetUserJobClientList');
  }

  getClientDetailsById(clientId: number): Observable<any> {
    const url = `Client/GetClientdetailsById?clientId=${clientId}`;
    return this.http.get<any>(url, { headers: this.headers });
  }

  addNewAddress(data) {
    return this.http.post<any>('AddressPool/Create', data);
  }

  getAddressTypes() {
    return this.http.get<any>('AddressPool/AddressTypes');
  }

  getAddressList(term) {
    const url = `AddressPool/AddressesForCombo`;
    return this.http.post<any>(url, term, { headers: this.headers });
  }

  postBulkClientUpdate(clientDetails: any): Observable<any> {
    const url = 'Client/PostBulkAddEditClient';
    const urlEncodedheaders: HttpHeaders = new HttpHeaders();
    urlEncodedheaders.set('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post<any>(url, clientDetails, { headers: urlEncodedheaders });
  }

  addEditClientContact(data) {
    let url = 'Client/AddEditClientContact?clientId=' + data.clientId + '&contactId=' + data.contactId + '&contextType=' + data.contextType + '&relationshipId=' + data.relationshipId + '&isContactDelete=' + data.isContactDelete + '&isImportant=' + data.isImportant;
    return this.http.post<any>(url, { headers: this.headers });
  }

  getNotificationsDetails(id: number) {
    return this.http.get<any>(`client/GetNotifications?Id=${id}`);
  }

  getDashboardNotificationsDetails() {
    return this.http.get<any>('client/GetTopNotifications?Id=' + 0);
  }

  getAddressDetailsByContextId(contextId: number, contextType: string) {
    return this.http.get<any>(`AddressPool/GetAddressDetailsByContextId?contextId=${contextId}&contextType=${contextType}`, { headers: this.headers });
  }

  bulkCRUDAddress(request: any) {
    return this.http.post<any>(`AddressPool/BulkCRUDAddress`, request, { headers: this.headers });
  }

  getContextDetailsForAddressPoolIds(addressPoolIds: string) {
    return this.http.get<any>(`AddressPool/GetContextDetailsForAddressPoolIds?addressPoolIds=${addressPoolIds}`, { headers: this.headers });
  }

  GetClientListForCombo() {
    return this.http.get<any>('Client/GetClientListForCombo', { headers: this.headers });
  }

  getNotificationasRead(notificationid, _lstNotifications) {
    return this.http.post<any>('Client/MarkNotificationasRead?NotificationId=' + notificationid + '&Ischecked=' + _lstNotifications, { headers: this.notificationHeaders });
  }

  getMarkAllAsRead() {
    return this.http.post<any>('Client/MarkAllAsRead', { headers: this.notificationHeaders });
  }

  setRemainderNotification(remind) {
    return this.http.post<any>('Client/SetReminderNotification', remind, { headers: this.notificationHeaders })
  }

  clearNotifications(res) {
    return this.http.get<any>('Client/ClearNotifications?res=' + res);
  }
  VerifyABNOrACNExistsInClients(clientId, input, checkfor) {
    return this.http.get<any>('Client/VerifyABNOrACNExistsInClients?clientId=' + clientId + '&input=' + input + '&checkFor=' + checkfor);
  }

  addNoteForJobTask(formData: FormData) {
    return this.http.post<any>('ClientProfile/AddNoteForJobTask', formData);
  }

  ValidateFinancialData(contextType, clientId, financialKey) {
    return this.http.get<any>('Client/ValidateFinancialData?contextType=' + contextType + '&clientId=' + clientId + '&financialKey=' + financialKey);
  }

  getBillingList() {
    return this.http.get<any>('Client/GetBillingList');
  }

  getBillingDetails(clientId) {
    return this.http.get<any>('Client/GetBillingDetails?clientId=' + clientId);
  }

  adjustedAmountData(adjustAmount) {
    return this.http.post<any>('Client/SaveAdjustedAmount', adjustAmount);
  }

  GetIndividualTypeClientContactDetails(cid) {
    return this.http.get<any>('Client/GetIndividualTypeClientContactDetails?ClientId=' + Number(cid) + '', { headers: this.headers })
  }

  AddEditCliententity(client, type = 'classic', dynamicCols: string = '', isCustomFields: boolean = false): Observable<any> {
    const extra = type === 'beta' ? '&dynamicCols=' + dynamicCols.split(',').filter(c => !!c).map(c => encodeURIComponent(c)).join(',') + '&isCustomFields=' + isCustomFields : '';
    return this.http.post<any>('Client/AddEditCliententity?type=' + type + extra, client, { headers: this.headers })
  }

  PostAddAssignEntityToClient(assignEntity) {
    return this.http.post<any>('Client/PostAddAssignEntityToClient', assignEntity, { headers: this.headers })
  }

  GetAssignStaffListByContext(contId, flag) {
    return this.http.get<any>('Client/GetAssignStaffListByContext?contId=' + contId + '&flag=' + flag)
  }

  AddContact(Contact) {
    return this.http.post<any>('Client/AddContact', Contact, { headers: this.headers })
  }

  AddEditContact(contactDataModal) {
    return this.http.post<any>('Client/AddEditContact', contactDataModal, { headers: this.headers })
  }

  PostDynamicFilter(dynamicfilterObj) {
    return this.http.post<any>('Client/PostDynamicFilter', dynamicfilterObj, { headers: this.headers })
  }

  GetClientById(ClientId) {
    return this.http.get<any>('Client/GetClientById?ClientId=' + ClientId);
  }

  GetSpouseDetailsByClientId(ClientId) {
    return this.http.get<any>('Client/GetSpouseDetailsByClientId?ClientId=' + ClientId);
  }

  GetDecryptedData(contextType, clientId) {
    return this.http.get<any>('Client/GetDecryptedData?ContextType=' + contextType + '&ClientId=' + clientId);
  }

  GetDecryptedDataDetails(contextType, Id, area) {
    return this.http.get<any>('Client/GetDecryptedDataDetails?ContextType=' + contextType + '&Id=' + Id + '&Area=' + area);
  }

  getClientDetailById(clientId: number) {
    return this.http.get<any>(
      `Client/GetClientdetailById?ClientId=${clientId}`
    );
  }

  getClientRelationshipTree(clientId: number) {
    return this.http.get<any>(
      `Client/GetClientRelationshipTree?ClientId=${clientId}`
    );
  }

  getClientRelationship(clientId: number) {
    return this.http.get<any>(`Client/GetClientRelationship?ClientId=${clientId}`);
  }

  addEditEntityClientRelationship(data: any) {
    return this.http.post<any>(
      'Client/AddEditEntityClientRelationship',
      data,
      { headers: this.headers }
    );
  }

  deleteClientRelation(id: number, clientId: number) {
    return this.http.get<any>(`Client/DeleteClientrelation?Id=${id}&ClientId=${clientId}`);
  }

  addEditClientDocument(jobDoc: any, formData: FormData) {
    return this.http.post<any>(
      `Client/AddEditClientDocument/?clientId=${Number(jobDoc.clientId)}&isPrivacy=${jobDoc.jobPrivacy}&docTypeId=${Number(jobDoc.docTypeId)}&tagId=${jobDoc.tagIds}&assignUserIds=${jobDoc.assignUserIds}`,
      formData,
      { headers: this.headers }
    );
  }

  addNoteForJob(formData: FormData) {
    const jobheaders: HttpHeaders = new HttpHeaders();
    jobheaders.set('Content-Type', 'multipart/form-data');
    return this.http.post<any>(
      'ClientProfile/AddNoteForJob',
      formData,
      { headers: jobheaders }
    );
  }

  getEmailTypes() {
    return this.http.get<any>(`EmailType/GetActiveEmailTypes`);
  }

  emailNotEmptyAndValid(Obj_email: any[]): boolean {
    return Obj_email.some(item => !!item.emailId?.trim() && item.isValid === false);
  }
  searchGlobalClients(searchText: string, searchType: number) {
    const params = new HttpParams()
      .set('searchText', searchText)
      .set('searchType', searchType.toString());

    return this.http.get<any>(
      'Client/GlobalQuickSearch',
      { params }
    );

  }

  GetGridViewDetailsById(viewId: number) {
    return this.http.get<any>('Client/GetGridViewDetailsById', {
      params: { id: viewId }
    });
  }

  getClientGroupCounts(requestData: any): Observable<any> {
    return this.http.post<any>('Client/GetClientGroupCounts', { value: requestData }, { context: noLoaderContextValue });
  }
  
  getColumnCustomizer() {
    return this.http.get<any>(`Client/GetClientListColumns`);
  }

  GetAllViewDetailsByUserId(GridType): Observable<any> {
    return this.http.get<any>('Client/GetAllViewDetailsByUserId?gridType=' + GridType, { headers: this.headers });
  }

  getPhoneTypes() {
    return this.http.get<any>(`Client/GetPhoneTypes`);
  }

  checkSharedEmail(request: { emailPoolIds: number[], contextId: number }) {
    return this.http.post<any>(`Client/CheckSharedEmail`, request);
  }
    
  bulkUpdateSharedEmails(request: any) {
    return this.http.post<any>('Client/BulkUpdateSharedEmails', request);
  }

  getGroupDetailsByClientId(clientId: number) {
    return this.http.get<any>(`client/GetClientGroupByClientId/${clientId}`);
  }

  phoneNotEmptyAndValid(Obj_phone: any[]): boolean {
    return Obj_phone.some(item => !!item.phoneNumber?.trim() && item.isValidPhone === false);
  }
  updateBpayReference(payload: any) {
    return this.http.post<any>(`Client/UpdateBpayReference`, payload);
  }
  QueueClientListExport(request: any) {
    return this.http.post<any>('Client/QueueClientListExport', request);
  }

}
